import { SVGProps } from 'react';

export default function LoopIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
			width="18px"
			height="18px"
			viewBox="0 0 1024 1024"
			{...props}
		>
			<path
				d="M293.376 645.290667A256.085333 256.085333 0 0 0 753.408 597.333333h89.173333a341.461333 341.461333 0 0 1-610.816 109.568L128 810.666667v-256h256l-90.624 90.624z m437.290667-266.624A256.170667 256.170667 0 0 0 270.506667 426.666667H181.333333a341.546667 341.546667 0 0 1 610.986667-109.653334L896 213.333333v256h-256l90.666667-90.666666z"
				fill="currentColor"
			/>
		</svg>
	);
}
